<template>
  <div>
    <h1 class="has-text-uppercase has-text-link is-size-4 my-4">
      <span class="has-text-primary">{{ count }} {{ $t("page.content.parcels") }}</span>
      {{ $t("page.headers.count_parcels") }}
    </h1>
    <ul class="parcel-list mb-3">
      <li v-for="parcel in parcels" :key="parcel.id">
        <router-link :to="{ name: 'parcel-detail', params: { id: parcel.id } }">
          <div class="parcel-list-card">
            <div class="img-container">
              <img src="@/assets/specie1.png" />
            </div>
            <div class="data">
              <p class="is-size-7 mb-1">
                <label class="parcel-label">{{ parcel.parcel.location }}</label>
              </p>
              <p class="mt-1">
                <span class="is-size-6 has-text-weight-semibold has-text-primary">
                  {{ parcel.service_request.super_status_label }}
                </span>
              </p>
              <p style="line-height: 1.2em">
                {{ parcel.get_status_display }}
              </p>
              <p class="mt-1">
                <label class="has-text-weight-normal mr-1">
                  {{ $t("page.labels.place") }}:
                </label>
                <span>{{ parcel.parcel.analysis_with_labels["Parroquia"] }}</span>
              </p>
            </div>
          </div>
        </router-link>
      </li>
    </ul>

    <div class="mb-1">
      <button
        class="button is-link is-outlined is-fullwidth"
        v-if="next"
        @click="nextPage()"
      >
        {{ $t("page.labels.show_more_parcels") }}
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api"

const PAGESIZE = 10

export default {
  name: "ParcelsList",
  mounted() {
    this.init()
  },
  data() {
    return {
      parcels: [],
      count: 0,
      next: null,
    }
  },
  methods: {
    init() {
      api
        ._get(`bikenta/service-request-parcels/?page_size=${PAGESIZE}`)
        .then((response) => {
          this.parcels = response.data.results
          this.count = response.data.count
          this.next = response.data.next
        })
    },
    nextPage() {
      api._rawGet(`${this.next}`).then((response) => {
        this.parcels = this.$_.union(this.parcels, response.data.results)
        this.next = response.data.next
      })
    },
  },
}
</script>
